import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BRAND } from '../../theme/brandTokens';

const ExpensesFallbackPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box id="expenses-fallback" sx={{ p: 4, textAlign: 'center' }}>
      <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
        {t('expenses.fallback.message')}
      </Typography>
      <Button
        id="expenses-fallback-stores"
        variant="contained"
        onClick={() => navigate('/management/stores')}
        sx={{ backgroundColor: BRAND.accent, color: BRAND.onAccent, '&:hover': { backgroundColor: BRAND.accentDark } }}
      >
        {t('expenses.fallback.goToStores')}
      </Button>
    </Box>
  );
};

export default ExpensesFallbackPage;
